import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class ScrollAnimation {
  constructor() {
    this.logoHeader = document.querySelector('.js-header__logo')
    this.logoHero = document.querySelector('.js-hero__logo')
    this.heroSection = document.querySelector('.js-hero__section')
    this.init()
  }

  init() {
    const animation = gsap.to(this.logoHeader, { opacity: 1 })

    ScrollTrigger.create({
      animation,
      trigger: this.heroSection,
      start: 'bottom top',
      toggleActions: 'play none none reverse',
    })
  }
}
